/**
 * Created by vadimpodlevsky on 22.03.2019.
 */
function after_form_submitted(data)
{
    console.debug(data);
    if(typeof data.success !== 'undefined')
    {
        console.debug('SUCCESS');
        if (typeof data.pay !== 'undefined') {
            // Generate hidden checkout form and submitting it to LIQPAY //
            $.get(
                data.checkout_form_url,
                {},
                function(html){
                    console.debug(html);
                    $('form#reused_form').after(html);
                    $('#checkout_form').submit();
                }
            );
        } else {
            $('form#reused_form').hide();
            $('#reg_form_title').hide();

            var $success_message = $('#success_message');
            var new_html = $success_message.html()
                    .replace('{first_name}', $('#first_name').val())
                    .replace('{last_name}', $('#last_name').val())
                ;

            if (data.auto_print_url) {

                var new_html = new_html
                        .replace('{auto_print_url}', data.auto_print_url)
                    ;

                console.debug('auto_print_url:'+data.auto_print_url);
                loadHiddenIframe('autoprint_iframe', data.auto_print_url);
            }

            if (data.auto_download_url) {

                var new_html = new_html
                        .replace('{auto_download_url}', data.auto_download_url)
                    ;

                console.debug('auto_download_url:'+data.auto_download_url);

                // window.location = data.auto_download_url;
                $.fileDownload(data.auto_download_url)
                    .done(function () { alert('File download success!'); })
                    .fail(function () { alert('File download failed!'); });

                // $.fileDownload(data.auto_download_url, {
                //     preparingMessageHtml: "We are generating your report, please wait...",
                //     failMessageHtml: "There was a problem generating your ticket.",
                //     httpMethod: "POST",
                //     data: $(this).serialize()
                // });
            }

            $success_message.html(new_html);
            $success_message.show();

            $('#error_message').hide();
            $('#form_header').hide();
            boostrap_validation_scroll_top();
        }
    }
    else
    {
        handleErrors(data.errors, data.errorFields);
    }//else
}

function retryPayment(checkout_form_url){
    $.get(
        checkout_form_url,
        {},
        function(html){
            console.debug(html);
            $('.container').after(html);
            $('#checkout_form').submit();
        }
    );
}

function handleErrors(errors, errorFields, $form){
    $('#error_message ul').remove();
    $('#error_message').append('<ul></ul>');

    var old_server_error_messaging = true;
    jQuery.each(errorFields,function(key,val)
    {
        console.debug('errorField:'+val+';error:'+errors[key]);
        if (key in errors) {
            var $field = $('#'+val);
            var field = $field.get(0);
            field.setCustomValidity(errors[key]);
            // field.reportValidity(errors[key]);
            old_server_error_messaging = false;
            $field.parent().find('.invalid-feedback').html(errors[key]);
        }
    });

    if (old_server_error_messaging) {
        jQuery.each(errors,function(key,val)
        {
            $('#error_message ul').append('<li>'+val+'</li>');
        });
        $('#success_message').hide();
        $('#error_message').show();
    }

    //reverse the response on the button
    $('button[type="button"]', $form).each(function()
    {
        var $btn = $(this);
        var label = $btn.prop('orig_label');
        if(label)
        {
            $btn.prop('type','submit' );
            $btn.text(label);
            $btn.prop('orig_label','');
        }
    });
}

function bootstrap_validation_init(){

    console.log('bts validation init');

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.getElementsByClassName('needs-validation');
    // Loop over them and prevent submission
    var validation = Array.prototype.filter.call(forms, function(form) {
        form.addEventListener('submit', function(event) {
            bootstrap_validation_submit_listener(event, form);
        }, true);
    });
    $('#email,#phone_number,#date_of_birth').keydown(function(){
        if ($(this).val() != '') {
            this.setCustomValidity("");
        }
    })
}

var dirty_bootstrap_validation_flag = false;

function bootstrap_validation_submit_listener(event, form) {

    // $cbx_group = $("input:checkbox[id^='info_source_']");
    // $cbx_group.prop('required', true);
    // if($cbx_group.is(":checked")){
    //     $cbx_group.prop('required', false);
    //     if (!$("#info_source_99").is(':checked')) {
    //         $("#info_source_other").prop('required', false);
    //     }
    // }

    var failed = false;

    if (!$( "input[name^='mcs']:checked" ).length) {
        $("[name^='mcs']").attr('required', true);
        failed = true;
    } else {
        $("[name^='mcs']").attr('required', false);
    }


    dirty_bootstrap_validation_flag = false;
    if (form.checkValidity() === false || failed) {
        event.preventDefault();
        event.stopPropagation();
        dirty_bootstrap_validation_flag = true;
        boostrap_validation_scroll_to_error();
        //console.debug('STOP');
    }
    form.classList.add('was-validated');
}

function boostrap_validation_scroll_to_error(){
    var errorElements = document.querySelectorAll(
        "input:invalid,select:invalid");
    if (errorElements.length < 1) {
        console.debug('Form is invalid but invalid element not found.');
    } else {
        console.debug(errorElements[0]);
    }
    $('html, body').animate({
        scrollTop: $(errorElements[0]).parent().offset().top
    }, 500, 'swing', function(){
        $(errorElements[0]).focus();
    });
}

function boostrap_validation_scroll_top(){
    $('html, body').animate({
        scrollTop: 0
    }, 500, 'swing');
}

$(function()
{

    bootstrap_validation_init();

    // const elem = document.querySelector('input[name="date_of_birth"]');
    // const datepicker = new Datepicker(elem, {
    //     format:'dd/mm/yyyy',
    //     buttonClass: 'btn'
    // });

    $('a.dropdown-item').click(function(){
        //remember selected language
        var expDate = new Date();

        expDate.setTime(expDate.getTime() + (365 * 24 * 60 * 60 * 1000)); //1 year

        $.cookie('lang', $(this).attr('lang'), {expires:expDate, path:"/"});
    })

    $('#reused_form').submit(function(e)
    {

        console.log('test1:'+dirty_bootstrap_validation_flag);

        if (dirty_bootstrap_validation_flag) {
            return;
        }

        console.log('test2');

        e.preventDefault();

        var $form = $(this);
        //show some response on the button
        $('button[type="submit"]', $form).each(function()
        {
            var $btn = $(this);
            $btn.prop('type','button' );
            $btn.prop('orig_label',$btn.text());
            $btn.append($('#dots_loader_img').html());
        });

        var formdata = new FormData(this);
        $.ajax({
            type: "POST",
            url: $(this).attr('url'),
            data: formdata,
            success: after_form_submitted,
            error: function(xhr, message, exception){
                console.debug('ERROR');
                handleErrors({message: exception, response:xhr.responseText}, null, $form)
            },
            dataType: 'json' ,
            processData: false,
            contentType: false,
            cache: false
        });

    });

    $('#info_source_other').focus(function(){
        $('#info_source_99').prop('checked', true);
    })
    // var cleave = new Cleave('#phone_number', {
    //     numericOnly: true,
    //     prefix: null,
    //     delimiters: ['+','(',')', '-', '-'],
    //     blocks: [0, 2, 3, 3, 2, 2]
    // })

    var cleave = new Cleave('#phone_number', {
        numericOnly: true,
        prefix: null,
        delimiters: ['+',' ',' ', ' '],
        blocks: [0, 2, 2, 3, 5]
    })

    var cleave = new Cleave('#date_of_birth', {
        date: true,
        delimiter: '/',
        datePattern: ['d', 'm', 'Y']
    });

    $('#phone_number').focus(function(){
        if ($(this).val() == ''){
            $(this).val('+');
        }
    }).focusout(function(){
        if ($(this).val() == '+'){
            $(this).val('');
        }
    })

    $('.container').scroll(function() {
        var x = $(this).scrollTop();
        $(this).css('background-position', '0% ' + parseInt(-x / 10) + 'px');
    });
});

function loadHiddenIframe(id, url) {
    // $("#"+id).remove();
    // $("<iframe style=\"position:absolute; left: -10000px; top: -10000px;\" id='"+id+"'>")
    //     .attr("src", url)
    //     .appendTo("body");

    $("#"+id).remove();
    $("<iframe id='"+id+"' name='"+id+"'>")
        .hide()
        .attr("src", url)
        .appendTo("body");
    $("#"+id).on("load", function(){
        function getChromeVersion () {
            var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./); return raw ? parseInt(raw[2], 10) : false;
        }
        if (getChromeVersion() >= 77) {
            window.frames[id].focus();
            window.frames[id].print();
        }
    })
}

// Example starter JavaScript for disabling form submissions if there are invalid fields
(function() {
    'use strict';
    window.addEventListener('load', function() {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function(form) {
            form.addEventListener('submit', function(event) {
                console.log('check validity');
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();